export const Filayer = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-container">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.99 26.54L12.62 20.81L11 22.07L20 29.07L29 22.07L27.37 20.8L19.99 26.54ZM20 24L27.36 18.27L29 17L20 10L11 17L12.63 18.27L20 24Z"
      fill="#242424"
    />
  </svg>
);
